// 公共
export const PurchaserRouterName = {
  /** 组合商品列表 */
  ProductCombinationList: '/purchaser/cookbook/product_combination/list',
  /** 组合商品详情 */
  ProductCombinationDetail: '/purchaser/cookbook/product_combination/detail',
  /** 组合商品编辑 */
  ProductCombinationEdit: '/purchaser/cookbook/product_combination/edit',
  /** 组合商品新增 */
  ProductCombinationAdd: '/purchaser/cookbook/product_combination/add',

  /** 缴费单 */
  PaymentReceipt: '/purchaser/cookbook/payment_receipt/list',
  /** 缴费单详情 */
  PaymentReceiptDetail: '/purchaser/cookbook/payment_receipt/detail',
  /** 缴费单新增 */
  PaymentReceiptCreate: '/purchaser/cookbook/payment_receipt/create',
  /** 缴费单编辑 */
  PaymentReceiptEdit: '/purchaser/cookbook/payment_receipt/edit',
  /** 缴费单报餐记录 */
  MealRecordDetail: '/purchaser/cookbook/meal_record/detail',

  /** 缴费记录 */
  PaymentRecords: '/purchaser/cookbook/payment_records/list',
  /** 缴费记录新建 */
  PaymentRecordsCreate: '/purchaser/cookbook/payment_records/create',

  /** 售后单 */
  AfterSales: '/purchaser/after_sales/list',
  /** 新增售后单 */
  AfterSalesCreate: '/purchaser/after_sales/create',
  /** 售后单详情 */
  AfterSalesDetail: '/purchaser/after_sales/detail',
  /**
   * 售后单编辑
   */
  AfterSalesEdit: '/purchaser/after_sales/edit',

  //  TODO:全局替换重复的
  /**
   * 采购单详情
   */
  PurchaseOrderDetail: '/purchaser/purchase_order/detail',
  /**
   * 对账单详情
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationDetail}/${statementNo}
   * */
  StatementDetail: '/purchaser/bill/reconciliation/detail',
  /* * 编辑对账单
   * @param string statementNo 采购单编号
   * @description 使用方式 ${ReconciliationEdit}/${statementNo}
   * */
  ReconciliationAddForPurchaser: '/purchaser/bill/reconciliation/purchase_edit',
  AfterSalseAddForPurchaser: '/purchaser/bill/reconciliation/after_sales_edit',

  /** 商品行情价 */
  MarketPriceList: '/purchaser/purchase_order/market_price/list',
  /** 商品行情价详情 */
  MarketPricesDetail: '/purchaser/purchase_order/market_price/detail',
  /** 商品行情价编辑 */
  MarketPricesEdit: '/purchaser/purchase_order/market_price/edit',
  /** 商品行情价创建 */
  MarketPricesCreate: '/purchaser/purchase_order/market_price/create',

  /** 折扣定价单详情 */
  DiscountPricesDetail: '/purchaser/purchase_order/discount_price/detail',

  /** 折扣定价单公示列表 */
  DiscountPricesPublic: '/purchaser/report/discount_price_public/list',
  /** 折扣定价单公示结果 */
  DiscountPricesResult: '/purchaser/report/discount_price_public/result',

  /** 合同详情 */
  PublicPurchaserContractDetail: '/purchaser/report/discount_price_public/contract_detail',

  /** 询价单列表 */
  InquiryList: '/purchaser/inquiry_quotation/inquiry/list',
  /** 询价单创建 */
  InquiryCreate: '/purchaser/inquiry_quotation/inquiry/create',
  /** 询价单详情 */
  InquiryDetail: '/purchaser/inquiry_quotation/inquiry/detail',
  /** 询价单比价定价 */
  InquiryComparePirce: '/purchaser/inquiry_quotation/inquiry/compare_price',
  /** 询价单编辑 */
  InquiryEdit: '/purchaser/inquiry_quotation/inquiry/edit',
  /** 询价单复制 */
  InquiryCopy: '/purchaser/inquiry_quotation/inquiry/copy',

  /** 采购合同列表 */
  PurchaserContractList: '/purchaser/purchase_contract/list',
  /** 编辑采购合同 */
  PurchaserContractEdit: '/purchaser/purchase_contract/edit',
  /** 采购合同 */
  PurchaserContractDetail: '/purchaser/purchase_contract/detail',
  PurchaserContractAddForQuation: '/purchaser/purchase_contract/quotation/add',

  /** 报价单列表 */
  QuotationList: '/purchaser/inquiry_quotation/quotation/list',
  /** 报价单详情 */
  QuotationDetail: '/purchaser/inquiry_quotation/quotation/detail',
};
